import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { clearUserData } from '@/helpers/logout-utils';
import { isInactiveAccountError } from '@/helpers/is-inactive-account-error';
import { isNoActiveSubscriptionError } from '@/helpers/is-no-active-subscription-error';
import { isUnauthorizedError } from '@/helpers/is-unauthorized-error';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';

import { useCurrentUser } from './use-current-user.query';

export const useCurrentUserAuthErrorRedirect = () => {
  const queryClient = useQueryClient();
  const navigateTo = useNavigateTo();
  const { error } = useCurrentUser();

  useEffect(() => {
    if (!error) return;

    if (isInactiveAccountError(error)) {
      clearUserData({ queryClient, useJotaiStore: true });
      navigateTo.signIn();
      return;
    }

    if (isNoActiveSubscriptionError(error)) {
      navigateTo.accountDisabled();
      return;
    }

    if (isUnauthorizedError(error)) {
      clearUserData({ queryClient, useJotaiStore: true });
      navigateTo.signIn();
    }
  }, [error, navigateTo, queryClient]);
};
